import { render, staticRenderFns } from "./DeleteTemplateModal.vue?vue&type=template&id=66b8dcfc&scoped=true"
import script from "./DeleteTemplateModal.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteTemplateModal.vue?vue&type=style&index=0&id=66b8dcfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b8dcfc",
  null
  
)

export default component.exports